export const sortByLabel = <T extends { label: string }>(a: T, b: T) =>
  a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1;
